import React, { forwardRef, memo, ReactNode, useMemo } from "react";

import "./index.scss"

export type Button = {
  label: string | ReactNode
  classes?: string[]
  type?: 'primary' | 'secondary' | 'tertiary' | 'ghost'
  size?: 'l' | 'm' | 's'
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  isActive?: boolean
  disabled?: boolean
}

const Button = memo(forwardRef<HTMLButtonElement, Button>(({
  label, classes = [], type = 'primary', size = 'l', onClick = () => {},
  isActive = false, disabled = false,
}, ref) => {
  const classNames = useMemo(() => {
    const classArr: string[] = ['Button', type, `size-${size}`]
    if (classes.length) classArr.concat(classes)
    if (isActive) classArr.push('active')
    if (disabled) classArr.push('disabled')

    return classArr.join(' ')
  }, [classes, isActive, disabled])

  return (
    <button
      ref={ref}
      className={classNames}
      tabIndex={0}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  )
}))

export default Button
